import { lazy } from 'react';

export const AddMaintenance = lazy(() => import('./schedule_maintenance/AddMaintenance'));
export const PreventiveMaintenanceList = lazy(() => import('./preventive_list/PreventiveMaintenanceList'));
export const CorrectiveMaintenanceList = lazy(() => import('./corrective_list/CorrectiveMaintenanceList'));
export const JobCardList = lazy(() => import('./job_order_list/JobCardList'));
export const MaintenanceHierarchy = lazy(() => import('../hyrarchy/MaintenanceHierarchy'));
export const StaffMaintenanceHierarchy = lazy(() => import('../hyrarchy/StaffMaintenanceHierarchy'));
